<template>
    <li class="pt-12 relative pl-6 md:pl-12 flex justify-content-between items-center">

        <span class="absolute flex justify-center items-center w-8 h-8 rounded-full shadow-lg bg-white text-gray-900 border-2 border-gray-900"
              style="top: 50%; left: -17px">
            <icon-device-mobile class="w-5 h-5"></icon-device-mobile>
        </span>

        <div class="flex justify-between items-start flex-grow-1">
            <div>
                <h4 class="flex items-center font-medium" :class="{'text-brand' : hasFailed }">
                    <span>Sms sent to {{ activity.source.to_name ? activity.source.to_name : activity.source.to }}</span>
                    <icon-message-failed class="ml-2 w-4 h-4 text-brand inline" v-if="hasFailed"></icon-message-failed>
                </h4>
                <p class="text-gray-500 font-normal text-sm" v-if="activity.source && activity.source.body">
                    {{ activity.source.body }}
                </p>
            </div>
            <div class="pl-4 text-gray-400 text-xs min-w-100 leading-tight">
                <div class="text-right whitespace-nowrap">{{ activity.source.created_at | date }}</div>
                <div class="text-right"><span>{{ activity.source.created_at | timeonly }}</span></div>
            </div>
        </div>
    </li>
</template>

<script>
import CommonProps from "../../../mixins/activity-common-mixin";

export default {

    mixins: [CommonProps],

    data () {
        return {};
    },

    computed: {
        hasFailed () {
            return this.activity && this.activity.source && this.activity.source.status === "failed";
        }
    }

};

</script>

<style scoped>
span.failed {
    background-color: #b11623;
    color: #FFF;
    padding: 3px 10px;
    margin-left: 10px;
    vertical-align: text-top;
}
</style>

